import { genericFetch } from "./common-service"
import { apiBaseUrl } from "./config"
import { LOCAL_AUTHORITIES, DEMOGRAPHIES } from "./constant/url-segment"
import { getBaseHeader } from "./utils"
import { Demography, LocalAuthority } from "../../model"
import { createDemographyRequestBody, createDemographyUpdateRequestBody } from "./factory";


export function createDemography(demography: Demography, localAuthority: LocalAuthority): Promise<Demography> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${localAuthority.id}/${DEMOGRAPHIES}`
	const init: RequestInit = {
		body: JSON.stringify(createDemographyRequestBody(demography)),
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		method: "POST"
	}

	return genericFetch<Demography>(url, init)
}

export function deleteDemography(demography: Demography, localAuthority: LocalAuthority): Promise<void> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${localAuthority.id}/${DEMOGRAPHIES}/${demography.year}`
	const init: RequestInit = {
		headers: getBaseHeader(),
		method: "DELETE"
	}

	return genericFetch<void>(url, init)
}

export function updateDemography(demography: Demography, localAuthority: LocalAuthority): Promise<Demography> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${localAuthority.id}/${DEMOGRAPHIES}/${demography.year}`
	const init: RequestInit = {
		body: JSON.stringify(createDemographyUpdateRequestBody(demography)),
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		method: "PUT"
	}

	return genericFetch<Demography>(url, init)
}


// WEBPACK FOOTER //
// ./src/service/sfp/demographies-service-2.ts